import Api from '../../../../Api';
import { IUserRetentionStatus } from '../../../../shared-interfaces/User/IUserRetentionStatus';
import { Inclusion } from '../../../../shared-types/Inclusion';
import { Role } from '../../../../shared-types/Roles';
import { IUserManagementFilter } from '../Interfaces/IUserManagementFilter';

const UserManagementService = {
  bulkUpdateUserRole: async (
    newRole: Role,
    userIds: string[],
    inclusion: Inclusion,
    searchParameters: IUserManagementFilter,
  ) => {
    const response = await Api.post('user/bulk-role-change', {
      newRole: newRole,
      searchParameters: {
        inclusion: inclusion,
        userIds: userIds,
        term: searchParameters.search,
        roleIds: searchParameters.roles,
        retentionStatusIds: searchParameters.retentionStatus,
      },
    });
    if (response.status != 200) throw response.status;
    return response.data;
  },
  bulkUpdateUserRetention: async (
    newRetentionStatus: number,
    userIds: string[],
    inclusion: Inclusion,
    effectiveDate: Date,
    searchParameters: IUserManagementFilter,
  ): Promise<IUserRetentionStatus[]> => {
    const response = await Api.post('user/bulk-retention-status-change', {
      statusId: newRetentionStatus,
      reason: '',
      effectiveDate: effectiveDate.toUTCString(),
      searchParameters: {
        inclusion: inclusion,
        userIds: userIds,
        term: searchParameters.search,
        roleIds: searchParameters.roles,
        retentionStatusIds: searchParameters.retentionStatus,
      },
    });
    if (response.status != 200) throw response.status;
    return response.data;
  },
};

export default UserManagementService;
